import { useQuery } from '@tanstack/react-query';

import { fetchMe } from 'apis/restaurant-api/merchant-admin/user/api';

export const useMe = () => {
  return useQuery(['/v1/user/me'], () => fetchMe(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
